import { useMemo } from 'react';
import { Radio, Space } from 'antd';
import { fitzpatrickScale } from './dermatologyUtils';

const DermatologySkinType = ({ question, value, onChange, disabled }) => {
  const options = useMemo(() => {
    if (!question) return [];
    
    try {
      return question.options || 
             (typeof question.option === 'string' ? JSON.parse(question.option).options : question.option?.options) || 
             [];
    } catch (error) {
      console.error('Error parsing Fitzpatrick question options:', error);
      return [];
    }
  }, [question]);

  if (!question || options.length === 0) return null;

  return (
    <div className="dermatology-skin-grid-container">
      <Radio.Group 
        value={value}
        onChange={onChange}
        disabled={disabled}
        className="dermatology-skin-grid"
      >
        {options.map((option) => {
          const skinData = fitzpatrickScale[option.value];
          
          return (
            <div 
              key={option.value} 
              className="dermatology-skin-item"
              onClick={() => !disabled && onChange({ target: { value: option.value } })}
              style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
            >
              <Space align="center">
                <div 
                  className="dermatology-skin-circle" 
                  style={{ backgroundColor: skinData?.color }}
                />
                <span className="dermatology-skin-text">{option.text}</span>
              </Space>
              <Radio value={option.value} checked={value === option.value} />
            </div>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default DermatologySkinType;
